<template>
  <defs>
    <!--  -->
    <marker id="arrow" markerWidth="10" markerHeight="10" refX="3" refY="4" orient="auto" markerUnits="userSpaceOnUse">
      <path d="M0,0 L0,8 L4,4 z" fill="#083277" />
    </marker>
    <marker
      id="arrowDrag"
      markerWidth="10"
      markerHeight="10"
      refX="3"
      refY="4"
      orient="auto"
      markerUnits="userSpaceOnUse"
    >
      <path d="M0,0 L0,8 L4,4 z" fill="hsl(205, 100%, 45%)" />
    </marker>
  </defs>
</template>

<script>
export default {};
</script>

<style></style>
